<pt-buttons-container>
  <button mat-flat-button color="primary" (click)="add()">
    Create Prescription Item
  </button>
</pt-buttons-container>
